import { config } from '_config';

export const sleep = async (ms) => new Promise((r) => setTimeout(r, ms));

export const getHostname = (fallback = null) => {
  if (typeof window !== 'undefined') {
    return `${window.location.hostname}${config.basePath}`;
  }

  return fallback;
};
